<div class="confirmation-dialog">
  <h2 [ngClass]="'header header__' + color">
    {{ title | translate }}
  </h2>
  <div class="content">
    <div *ngIf="isLockMasterData">
      <div>
        {{ 'municipal_master_data.lock_master_data.dialog.error.header_text' | translate }}
      </div>
      <ul>
        <li *ngFor="let message of extraData">
          {{ message | translate }}
        </li>
      </ul>
      <div>
        {{ 'municipal_master_data.lock_master_data.dialog.error.footer_text' | translate }}
      </div>
    </div>
    <div *ngIf="!isLockMasterData">
      <div class="description-text">
        {{ description | translate }}
      </div>
      <div *ngIf="extraData?.length ?? 0 > 0">
        <div class="mt-5" *ngIf="extraDataPrefix">
          <div>
            <span class="text--bold">{{ extraDataPrefix | translate }}:</span>
          </div>
        </div>
        <ul>
          <li *ngFor="let message of extraData">
            {{ message | translate }}
          </li>
        </ul>
      </div>
      <div *ngIf="descriptionBelowExtraData" [class.text--bold]='boldDescriptionBelowExtraData'>
        {{ descriptionBelowExtraData | translate }}
      </div>
    </div>
    <div class="mt-5" *ngIf="remarkDescription && remarkDescriptionPrefix">
      <div>
        <span class="text--bold">{{ remarkDescriptionPrefix | translate }}:</span> {{ remarkDescription | translate }}
      </div>
    </div>
    <div class="action">
      <button (debounceClick)="onContinueClicked()" color="primary" valgButton valgDebounceButton>
        {{ data.affirmText ?? "dialog.continue" | translate }}
      </button>
      <button (click)="onCancelClicked()" color="text-only" valgButton *ngIf="!data.hideCancelButton">
        {{ data.cancelText ?? "dialog.cancel" | translate }}
      </button>
    </div>
  </div>
</div>